import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import type { DriveMapping } from '../../utils/api';

export function DriveMetelImagesEditor({ mapping, onSave, onSaved, onClose }: {
  mapping?: DriveMapping;
  onSave: (mapping: DriveMapping) => Promise<{ data: DriveMapping }>;
  onSaved: () => void;
  onClose: () => void;
}) {
  const [name, setName] = useState(mapping?.name || 'Immagini METEL da Drive');
  const save = useMutation({
    mutationFn: () => onSave({ id: mapping?.id || crypto.randomUUID(), name: name.trim(),
      target: 'prodotti', keys: { codice: 'codice_metel' }, fields: {}, options: {} }),
    onSuccess: () => { toast.success('Processo salvato'); onSaved(); },
    onError: (error) => toast.error((error as { response?: { data?: { detail?: string } } })?.response?.data?.detail || 'Operazione non riuscita'),
  });
  return <section className="space-y-4 rounded border bg-white p-4" aria-label="Importazione immagini METEL">
    <h3 className="font-semibold">Immagini METEL</h3>
    <p className="text-sm text-gray-600">Legge i record IIT e associa le immagini ai prodotti tramite codice METEL. Salva WebP ottimizzate, aggiunge le nuove immagini e salta quelle già importate. Le immagini e la principale esistenti vengono mantenute.</p>
    <label className="flex flex-col text-sm">Nome processo<input className="rounded border border-gray-300 p-2 text-sm" value={name} onChange={event => setName(event.target.value)} /></label>
    <div className="flex gap-3">
      <button className="rounded border p-2 text-sm" disabled={save.isPending || !name.trim()} onClick={() => save.mutate()}>Salva processo</button>
      <button className="rounded border p-2 text-sm" disabled={save.isPending} onClick={onClose}>Annulla</button>
    </div>
  </section>;
}
